import { EpimsBaseEntityDto } from './epim-base.dto';
export class LandParcelDto extends EpimsBaseEntityDto {
  LandParcelId: string;
  SectionName: string;
  PurposeId: string;
  TotalArea: number;
  MeasureId: string;
  Cost: string;
  Acre: number;
  Hectare: number;
  SqKM: number;
  SqM: number;
  SqFeet: number;
  Roods: number;
  Perche: number;
  Plot: number;
  LandTitleId: string;
  SubscriptionUserId: string;
  RowIdLinkage: string;
  URLMap: string;
  LandParcelCode: string;
}
